import React from "react";
import PropTypes from "prop-types";
import { camel } from "case";
import { RCL } from "../RCL";
// eslint-disable-next-line import/no-cycle
import { RichText } from "../RichText";
import { CountdownBanner } from "./CountdownBanner";

const CountdownBannerConnector = ({ data }) => {
	const getSectionPadding = () => {
		if (data?.layoutMargin === "bottom") {
			return "top";
		}
		if (data?.layoutMargin === "both") {
			return "default";
		}

		if (data?.layoutMargin === "none") {
			return "none";
		}
		return "bottom";
	};

	const timeLabels = {
		days: <RCL searchKey="day-s" />,
		hours: <RCL searchKey="hour-s" />,
		minutes: <RCL searchKey="min-s" />,
		seconds: <RCL searchKey="sec" />,
	};

	const sectionPadding = getSectionPadding();

	return (
		<CountdownBanner
			endDate={data?.endDate}
			message={<RichText data={data?.message} />}
			colorVariant={camel(data?.colorVariant)}
			sectionPadding={sectionPadding}
			labels={timeLabels}
		/>
	);
};

CountdownBannerConnector.propTypes = {
	data: PropTypes.shape({
		endDate: PropTypes.string.isRequired,
		message: PropTypes.shape({
			childMarkdownRemark: PropTypes.shape({
				html: PropTypes.string,
			}),
		}).isRequired,
		colorVariant: PropTypes.oneOf(["pinkOrchid", "coralReef", "seaFoam"]),
		layoutMargin: PropTypes.oneOf(["top", "bottom", "both", "none"]),
	}),
};

CountdownBannerConnector.defaultProps = {
	data: {
		colorVariant: "pinkOrchid",
		layoutMargin: "top",
	},
};

export default CountdownBannerConnector;
export { CountdownBannerConnector };
